module.exports = __webpack_public_path__ + "img/box2_icon2.5f5e0610.png";